export default {
  locations: {
    title: 'Settings',
    list: {
      columns: {
        locationName: 'Location name',
        cityAndState: 'City and State',
        address: 'Address',
        phone: 'Phone'
      }
    }
  },
  businessProfile: {
    description:
      'Edit your business profile so members can easily learn more about your business.',
    tabs: {
      generalInfo: 'General Info',
      brandAndColor: 'Brand & Color',
      operatingHours: 'Operating Hours'
    }
  },
  generalInfo: {
    fields: {
      name: 'Business name',
      phone: 'Phone number',
      category: 'Business category',
      otherCategory: 'Category name',
      website: 'Website',
      websiteExample: 'E.g. coffe-bits.com',
      instagram: 'Instagram',
      instagramPlaceholder: 'username',
      instagramExample: 'E.g. coffee.bits',
      facebook: 'Facebook',
      facebookPlaceholder: 'pagename',
      facebookExample: 'E.g. CoffeeBits'
    },
    successNotification: 'Profile updated successfully!'
  },
  hoursOfOperation: {
    show: 'Show',
    sync: {
      title: 'Syncing Opening Hours with Google APIs',
      description:
        'Your business hours are currently synced with Google API data. Disable syncing to manually edit this information.'
    },
    selectLocation: 'Select your location',
    sameTimeForAllLocations: 'Same time for all locations',
    open: 'Open',
    closed: 'Close',
    to: 'to',
    days: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    },
    errors: {
      missingTime: 'Invalid input: On {day}, time field is not filled in',
      sameTime:
        'Invalid input: On {day}, the opening time is the same as the closing time',
      maxPeriods:
        'You have reached the maximum number of periods allowed per day'
    },
    successNotification: 'Success updated operating hours!'
  },
  manageTeam: {
    title: 'Settings',
    heading: 'Team',
    list: {
      columns: {
        user: 'User',
        status: 'Status',
        role: 'Role'
      }
    },
    status: {
      accepted: 'Accepted',
      pending: 'Pending'
    },
    roles: {
      owner: 'Manager',
      member: 'User'
    },
    actions: {
      transfer: 'Transfer Management',
      remove: 'Remove user',
      resend: 'Resend Invitation',
      removeInvite: 'Remove Invitation'
    },
    addUser: {
      title: 'Add User',
      description:
        "Enter the email and name of the user you want to add, and we'll send them an invite to join your team.",
      name: 'Name',
      email: 'Email',
      submit: 'Send invite'
    },
    transferDialog: {
      title: 'Transfer management',
      description: 'You are about to transfer the management to <b>{name}</b>.',
      cancel: 'Cancel',
      confirm: 'Transfer'
    },
    notifications: {
      invitationSent: 'Invitation sent',
      managementTransferred: 'Management transferred',
      userRemoved: 'User removed',
      invitationRemoved: 'Invitation removed',
      invitationResent: 'Invitation resent'
    }
  }
};
